import React, { FunctionComponent } from "react";
import { connect } from "react-redux";
import State from "../../app/state";

interface OwnProps {
  children: (id: string) => React.ReactNode;
}

interface Properties {
  sectionIds: Array<string>;
}

type AllProperties = OwnProps & Properties;

const ForEachSection: FunctionComponent<AllProperties> = ({
  sectionIds,
  children,
}) => {
  return (
    <>
      {sectionIds.map((id) => (
        <div key={id}>{children(id)}</div>
      ))}
    </>
  );
};

const mapStateToProps = (state: State): Properties => {
  return {
    sectionIds: Object.keys(state.sectionResults),
  };
};

export default connect(mapStateToProps)(ForEachSection);
